import { Component } from "react";
import { TYPING_TIMEOUT } from "../../../constants";
import CustomizedTextField from "../../Input/CustomizedTextField";
import { getCurrentFunctionName } from "../../../performanceModeManager";

const MAX_INT_VALUE = 2147483647;

class InterventionIntegerField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value.value_int,
            timeout: TYPING_TIMEOUT,
            typedJustNow: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.typedJustNow) return state;

        let currentValue = props.value.value_int;

        state.value = currentValue;
        return state;
    }

    handleChange(e) {
        let input = e.target.value.replace(/^0+/, "");
        let intValue = parseInt(input, 10);
        let value = intValue;

        if (input !== "" && input !== intValue.toString()) return;

        if (intValue > MAX_INT_VALUE || intValue < -MAX_INT_VALUE) return;

        if (input === "") value = "";

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            value,
            typedJustNow: true,
            typingTimeout: setTimeout(() => {
                let fieldValue = this.props.value;
                fieldValue.value_int = value;
                this.props.fieldValueChange(fieldValue);

                this.setState({
                    typedJustNow: false,
                });
            }, this.state.timeout),
        });
    }

    onClick = (ev) => {
        const el = ev.target;
        if (document.activeElement !== el) {
            setTimeout(() => {
                if (el.select) el.select();
            }, 0);
        }
    };

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <CustomizedTextField
                onChange={this.handleChange.bind(this)}
                value={this.state.value}
                {...this.props.inputProperties}
                label={this.props.model.name}
                type={this.props.type}
                className={this.props.inputProperties.className + " full_size control-margin-top"}
                onMouseDown={this.onClick}
            />
        );
    }
}

export default InterventionIntegerField;
